(function () {

    "use strict";

    app.controller("ieDeprecationWarningModal", ieDeprecationWarningModal);

    ieDeprecationWarningModal.$inject = ['$scope', 'modalData'];

    function ieDeprecationWarningModal($scope, modalData) {

        var self = this;

        var init = function () {
            self.location = document.URL;
        }

        self.remindLater = function () {
            HStorageManager.put({
                storageLevel:  HStorageManager.StorageLevels.SESSION,
                key: 'hideIEWarningModal',
                value: true
            });
            self.close();
        }

        self.close = function () {
            $scope.$hide();
        };

        init();
    }
})(angular.module('harriApp'));